<template>
  <aside
    class="sidebar"
    :class="{ 'hide-sidebar': hideSidebar }"
    id="navigation-sidebar"
  >
    <div class="sidebar-content">
      <div class="sidebar-brand">
        <div class="sidebar-brand-inner">
          <img src="/images/lga-logo.png" alt="LGA Logo" class="img-fluid" />
        </div>
      </div>
      <ul class="sidebar-nav">
        <li class="sidebar-nav-text">Welcome, {{ name }}</li>

        <div :key="index" v-for="(group, index) in navigation">
          <template v-if="group.items.length > 0">
            <li class="sidebar-nav-title" v-if="group.label">
              {{ group.label }}
            </li>

            <sidebar-link
              :url="item.url"
              :icon="item.icon"
              :label="item.label"
              :key="i"
              v-for="(item, i) in group.items"
            ></sidebar-link>
          </template>
        </div>
      </ul>
    </div>
  </aside>
</template>

<script>
import PreLoader from './../Generic/PreLoader.vue';
import SidebarLink from '@/components/Layout/MainSidebar/SidebarLink';

export default {
  props: {
    hideSidebar: {
      type: Boolean,
      default: false
    }
  },

  components: {
    SidebarLink
  },

  data() {
    return {
      loading: true,
      groups: [
        {
          label: null,
          items: [
            {
              url: '/dashboard',
              icon: 'dashboard',
              label: 'Dashboard',
              permissions: null
            },
            {
              url: '/search',
              icon: 'search',
              label: 'Search',
              permissions: ['claims.search', 'invoices.search']
            },
            {
              url: '/all-claims',
              icon: 'view_list',
              label: 'All Claims',
              permissions: ['claims.allClaims']
            },
            {
              url: '/companies',
              icon: 'location_city',
              label: 'Companies',
              permissions: ['companies.read']
            },
            {
              url: '/insurers',
              icon: 'verified_user',
              label: 'Insurers',
              permissions: ['insurers.read']
            }
          ]
        },
        {
          label: 'Incidents',
          items: [
            {
              url: '/first-notice-of-loss',
              icon: 'folder',
              label: 'FNOL',
              permissions: ['claims.fnol']
            },
            {
              url: '/qualification',
              icon: 'playlist_add_check',
              label: 'Qualification',
              permissions: ['claims.qualification']
            },
            {
              url: '/deployment',
              icon: 'send',
              label: 'Deployment',
              permissions: ['claims.deployment']
            },
            {
              url: '/claim-monitoring',
              icon: 'navigation',
              label: 'Claim Monitoring',
              permissions: ['claims.claimsMonitoring']
            },
            {
              url: '/recovery',
              icon: 'build',
              label: 'Recovery',
              permissions: ['claims.recovery']
            },
            {
              url: '/rejected',
              icon: 'thumb_down',
              label: 'Rejected',
              permissions: ['claims.rejected']
            },
            {
              url: '/closed',
              icon: 'check_circle',
              label: 'Closed',
              permissions: ['claims.closed']
            }
          ]
        },
        {
          label: 'Fleet Management',
          items: [
            {
              url: '/fleet',
              icon: 'directions_car',
              label: 'Fleet',
              permissions: ['fleet.create']
            },
            {
              url: '/defleet',
              icon: 'car_crash',
              label: 'Defleet',
              permissions: ['fleet.delete']
            },
            {
              url: '/penalties',
              icon: 'gavel',
              label: 'Penalties',
              permissions: ['penalties.create']
            },
            {
              url: '/recharges',
              icon: 'request_quote',
              label: 'Recharges',
              permissions: ['recharges.create']
            },
            {
              url: '/runs',
              icon: 'location_on',
              label: 'Runs',
              permissions: ['runs.create']
            },
            {
              url: '/jobs',
              icon: 'work',
              label: 'Jobs',
              permissions: ['jobs.create']
            },
            {
              url: '/pdi-queue',
              icon: 'manage_search',
              label: 'PDI Queue',
              permissions: ['pdi.create']
            },
            {
              url: '/qc-queue',
              icon: 'fact_check',
              label: 'Quality Check',
              permissions: ['qc.create']
            }
          ]
        },
        {
          label: 'Admin',
          items: [
            {
              url: '/users',
              icon: 'person',
              label: 'Users',
              permissions: ['users.create']
            },
            {
              url: '/mi',
              icon: 'insights',
              label: 'MI',
              permissions: ['mi.read']
            }
          ]
        }
      ]
    };
  },

  updated() {
    this.loading = false;
    let sidebar = document.getElementById('navigation-sidebar');
    new window.Ps(sidebar);
  },

  computed: {
    name() {
      return (
        this.$store.getters.user.first_name +
        ' ' +
        this.$store.getters.user.last_name
      );
    },

    isSuperAdmin() {
      return this.$store.getters.user.super_admin;
    },

    navigation() {
      return this.groups.map(group => {
        return {
          ...group,
          items: group.items.filter(item => {
            // If the item has no permissions attached to it then it can always display
            if (!item.permissions) {
              return true;
            }

            // If any of the permissions are enabled then display
            return item.permissions.reduce((display, permission) => {
              if (display) {
                return display;
              }

              return this.hasPermission(permission);
            }, false);
          })
        };
      });
    }
  },

  mounted() {
    let sidebar = document.getElementById('navigation-sidebar');
    new window.Ps(sidebar);
  }
};
</script>
